import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys, type ResponseBody } from '../react-query.config';
import { isGameEnabled } from '@/lib/platform-filters';

type AdminPickemsResponse = ResponseBody<'/api/admin/pickems', 'get'>;
export type Pickem = AdminPickemsResponse['pickems'][number];

interface GetPickemsParams {
  limit?: number;
  offset?: number;
  status?: string;
}

export const getPickems = (params?: GetPickemsParams) =>
  apiClient.get('/api/admin/pickems', { params });

export const useGetPickemsQuery = (params?: GetPickemsParams, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeys.pickems.list(params),
    queryFn: () => getPickems(params),
    select: data => data.pickems || [],
    // A game this client didn't deploy has no admin routes registered, so asking is a
    // guaranteed 404. The caller's own opt-out still applies on top.
    enabled: isGameEnabled('pickem') && options?.enabled !== false,
  });
};
